<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:unarchive-item', $attrs.item)"
    >
    <slot>
    <v-icon color="blue">mdi-backup-restore</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'UnarchiveItemAction',
  extends: VBtn,
}
</script>

